import React, { useRef, useCallback, useEffect, useImperativeHandle } from 'react';
import 'pannellum/src/js/libpannellum';
import 'pannellum/src/js/pannellum';
import 'pannellum/src/css/pannellum.css';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Pannellum = function Pannellum(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["style", "className"]);

  var containerRef = useRef(null);
  var pannellumRef = useRef(null);
  var consoleClickInfo = useCallback(function (e) {
    var _pannellumRef$current3;

    if (!pannellumRef.current) {
      console.warn('viewer not exist');
      return;
    }

    var _pannellumRef$current = (_pannellumRef$current3 = pannellumRef.current) === null || _pannellumRef$current3 === void 0 ? void 0 : _pannellumRef$current3.mouseEventToCoords(e),
        _pannellumRef$current2 = _slicedToArray(_pannellumRef$current, 2),
        pitch = _pannellumRef$current2[0],
        yaw = _pannellumRef$current2[1];

    console.log('click info', {
      pitch: pitch,
      yaw: yaw
    });
  }, []);
  useEffect(function () {
    var _pannellumRef$current4;

    var clickInfo = restProps.clickInfo,
        params = _objectWithoutProperties(restProps, ["clickInfo"]);

    pannellumRef.current = window.pannellum.viewer(containerRef.current, _objectSpread2({}, params));
    if (clickInfo) (_pannellumRef$current4 = pannellumRef.current) === null || _pannellumRef$current4 === void 0 ? void 0 : _pannellumRef$current4.on('mousedown', consoleClickInfo);
    return function () {
      var _pannellumRef$current6;

      try {
        var _pannellumRef$current5;

        (_pannellumRef$current5 = pannellumRef.current) === null || _pannellumRef$current5 === void 0 ? void 0 : _pannellumRef$current5.off('mousedown', consoleClickInfo);
      } catch (_unused) {}

      (_pannellumRef$current6 = pannellumRef.current) === null || _pannellumRef$current6 === void 0 ? void 0 : _pannellumRef$current6.destroy();
    };
  }, [restProps]);
  useImperativeHandle(ref, function () {
    return {
      getViewer: function getViewer() {
        return pannellumRef.current;
      }
    };
  });
  return React.createElement("div", {
    className: className,
    style: style,
    ref: containerRef
  });
};

var index = React.forwardRef(Pannellum);

export default index;
